import { defineComponent as _defineComponent } from 'vue'
import { ref, onMounted, watch } from "vue";

export default /*@__PURE__*/_defineComponent({
  __name: 'commonArea',
  props: {
    fieldlabel: { type: String, default: "" },
    type: { type: String, default: "text" },
    modelValue: { type: String, required: true, default: "" },
    name: { type: String, required: true },
    propname: { type: String, required: false },
    autoResize: Boolean,
    cols: { type: Number, default: 30 },
    rows: { type: Number, default: 5 },
    IsreadOnly: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    inputclass: { type: String, default: "", },
    v$: Object,
    showLength: { type: Boolean, default: false },
    maxLength: { type: Number, default: 250 }
},
  emits: ["update:modelValue"],
  setup(__props, { expose: __expose, emit: __emit }) {
  __expose();

const InputValue = ref();
const emit = __emit;
const Props = __props;
const updateValue = (value: any) => {
    emit("update:modelValue", value);
};
const totalChar = ref();
const charCount = () => {
    if (Props.modelValue != null && Props.modelValue != '')
        totalChar.value = (Props.maxLength - Props.modelValue.length);
}
onMounted(() => {
    totalChar.value = Props.maxLength;
});
watch(() => Props.modelValue, () => {
    updateValue(Props.modelValue);
    charCount();
});

const __returned__ = { InputValue, emit, Props, updateValue, totalChar, charCount }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})